import { Form } from "antd";
import { FC } from "react";
import SwitchInput from "../../../components/form/switchInput";
import _t from "../../../lang/translate";
import format from "../../../utilities/formatNumbers";
import { isNum } from "../../../utilities/typeGuard";
import { InsuranceOutputType } from "./calc/addons/insuranceCalcTypes";

const LeasingInsuranceGlassDamage: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const shouldUpdate = (curr: any, next: any) =>
    curr?.insuranceOutput?.glassDamage !== next?.insuranceOutput?.glassDamage;

  return (
    <Form.Item noStyle shouldUpdate={shouldUpdate}>
      {({ getFieldsValue }) => {
        const insuranceOutput: InsuranceOutputType = getFieldsValue(true)?.insuranceOutput;
        const { glassDamageMonthlyPayment, glassDamageSelfRisk } = insuranceOutput || {};
        //TODO add monthly amount on insurance calc
        const glassDamageRender =
          isNum(glassDamageMonthlyPayment) && glassDamageMonthlyPayment > 0 ? (
            <>
              <label>
                {format.number(glassDamageMonthlyPayment)} {_t("krone_per_month")}
              </label>
            </>
          ) : (
            ""
          );

        return (
          <Form.Item valuePropName="checked" label={_t("glass_damage")} name={["insuranceInput", "glassDamage"]}
            extra={`${_t('own_risk')}: ${format.price(glassDamageSelfRisk)}`}
            className="mb-05">
            <SwitchInput disabled={disabled} size="small" label={glassDamageRender} />
          </Form.Item>
        );
      }}
    </Form.Item>
  );
};

export default LeasingInsuranceGlassDamage;
